import * as angular from 'angular';
import { ClassOfDropdownComponent } from './class-of-dropdown.component';

export const ClassOfDropdownModule = angular
  .module('classOfDropdownModule', [])
  .component('classOfDropdown', ClassOfDropdownComponent).name;
